import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import lod_ from "lodash";
import {
	Dialog,
	DialogActions,
	DialogContent,
	DialogTitle,
	Icon,
	IconButton,
	Tooltip,
	CircularProgress
} from "@mui/material";
import MDBox from "components/Basics/MDBox";
import MDButton from "components/Basics/MDButton";
import TextAreaScrollable from "components/Custom/TextAreaScrollable";
import KnowledgeActions from "redux-react/actions/knowledgeActions";
import { display } from "redux-react/reducers/snackBarReducer";
import { t } from "i18next";

/**
 * SplitKnowledge component
 * Allows splitting a knowledge into two parts: original content and new content.
 * @param {Object} props - Component properties
 * @param {Object} props.knowledge - The knowledge to split.
 * @param {Function} props.reload - Function to reload the knowledge after splitting.
 * @returns {JSX.Element} The rendered component.
 */
const EditKnowledge = ({ knowledge, reload = () => {} }) => {
	const dispatch = useDispatch();
	const [loading, setLoading] = useState(false);
	const [content, setContent] = useState(knowledge?.content || "");
	const [openDialog, setOpenDialog] = useState(false);

	/**
	 * Handle save action
	 * @returns {void}
	 */
	const onSave = () => {
		if (lod_.isNil(knowledge.uuid)) {
			return;
		}
		setLoading(true);
		dispatch(
			KnowledgeActions.updateKnowledge(
				knowledge.uuid,
				{ content },
				() => {
					dispatch(
						display({
							type: "success",
							message: t("FAIQ.SUCCESS.knowledgeUpdated")
						})
					);
					setLoading(false);
					setOpenDialog(false);
					reload();
				},
				() => {
					setLoading(false);
					dispatch(
						display({
							type: "error",
							message: t("FAIQ.ERROR.errorWhileUpdateKnowledge")
						})
					);
				}
			)
		);
	};

	useEffect(() => {
		setContent(knowledge?.content || "");
	}, [knowledge]);

	return (
		<MDBox>
			{/* Button */}
			<Tooltip title={t("SETTINGS.edit")} placement="top">
				<IconButton size="small" onClick={() => setOpenDialog(true)}>
					<Icon>edit</Icon>
				</IconButton>
			</Tooltip>
			{/* Dialog */}
			<Dialog
				fullWidth
				open={openDialog}
				PaperProps={{
					sx: {
						height: "95%",
						width: "100%",
						maxWidth: "100%"
					}
				}}
			>
				<DialogTitle>{t("FAIQ.ACTIONS.editContent")}</DialogTitle>
				<DialogContent
					sx={{ display: "flex", flexDirection: "column", height: "100%", overflow: "hidden" }}
				>
					<TextAreaScrollable
						value={content}
						onChange={e => setContent(e.target.value)}
						placeholder={t("FAIQ.ACTIONS.editContentPlaceholder")}
						disabled={loading}
					/>
				</DialogContent>
				<DialogActions>
					<MDButton
						variant="outlined"
						color="info"
						onClick={() => setOpenDialog(false)}
						disabled={loading}
					>
						{t("SETTINGS.cancel")}
					</MDButton>
					{!loading && (
						<MDButton variant="contained" color="info" onClick={onSave} disabled={loading}>
							{t("SETTINGS.save")}
						</MDButton>
					)}
					{loading && (
						<MDButton variant="contained" color="info" disabled>
							<CircularProgress size={24} color="white" />
							&nbsp;{t("SETTINGS.saving")}
						</MDButton>
					)}
				</DialogActions>
			</Dialog>
		</MDBox>
	);
};

export default EditKnowledge;
